import styled, { css, FlattenSimpleInterpolation } from 'styled-components';

import { Color, FontWeight, ZIndex } from '../../../enums';
import { StyledComponent } from '../../../interfaces';
import { MenuPosition } from '../../menuPosition/menuPosition.component';

import { ContainerProps } from './onTopSimpleMenu.types';

export const Container: StyledComponent<'div', ContainerProps> = styled.div<ContainerProps>`
  z-index: ${ZIndex.Hidden};
  position: fixed;
  bottom: 20px;
  left: 20px;
  right: 20px;
  pointer-events: none;
  transition: 0.3s;
  opacity: 0;

  ${({ $isVisible }: ContainerProps): string | false => $isVisible && `
    pointer-events: initial;
    opacity: 1;
    z-index: ${ZIndex.OnTopSimpleMenu};
  `};
`;

export const MenuPositions: StyledComponent<'div'> = styled.div``;

const buttonStyle: FlattenSimpleInterpolation = css`
  font-weight: ${FontWeight.Medium};
  font-size: 16px;
  line-height: 22px;
  padding: 16px 0 18px;
  width: 100%;
  text-align: center;
`;

export const MenuPositionItem: StyledComponent<typeof MenuPosition> = styled(MenuPosition)`
  ${buttonStyle}
  color: ${Color.Black};
  background-color: ${Color.White};

  & + & {
    border-top: 1px solid ${Color.Gray300};
  }
`;

export const CloseButton: StyledComponent<'button'> = styled.button`
  ${buttonStyle}
  margin-top: 12px;
  color: ${Color.White};
  background-color: ${Color.Black};
`;
